"use client";

import { Instagram, Youtube, Music2, Video, Plus } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[0, 1, 2, 3, 4].map(i => <li key={i} data-index={i}>
            <div className="h-4 w-24 bg-muted animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-foreground/80 hover:text-primary transition-colors duration-200 text-sm tracking-wide font-default">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
const servicesLinks = [{
  label: "Balayage",
  to: "/ArtistryPage"
}, {
  label: "Precision Cuts",
  to: "/ArtistryPage"
}, {
  label: "Deep Conditioning",
  to: "/ArtistryPage"
}, {
  label: "Color Correction",
  to: "/ArtistryPage"
}, {
  label: "Pricing Guide",
  to: "/BookPage"
}];
const socials = [{
  name: "Instagram",
  icon: Instagram,
  href: "#"
}, {
  name: "YouTube",
  icon: Youtube,
  href: "#"
}, {
  name: "Vimeo",
  icon: Video,
  href: "#"
}, {
  name: "TikTok",
  icon: Music2,
  href: "#"
}];
const tickerItems = ["MODERN HAIRCUTS", "VIBRANT COLOR", "BESPOKE STYLING"];
export default function Footer() {
  return <section data-section-id="3923" id="footer" className="relative overflow-hidden bg-background text-foreground border-t border-border">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.03]" style={{
      backgroundImage: "radial-gradient(circle, var(--foreground) 1px, transparent 1px)",
      backgroundSize: "24px 24px"
    }} aria-hidden="true" />

      {}
      <div className="absolute inset-x-0 top-0 flex justify-center pointer-events-none overflow-hidden select-none" aria-hidden="true">
        <span className="font-serif font-bold leading-none text-foreground/[0.06] tracking-tight whitespace-nowrap" style={{
        fontSize: "clamp(8rem, 18vw, 16rem)"
      }}>
          VELVET
        </span>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 lg:pt-24 pb-6">
        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          {}
          <div className="space-y-6">
            <div className="flex items-center gap-3">
              
              <Separator className="flex-1 bg-border" />
            </div>

            <Link to="/" className="inline-block">
              <WvcLogo className="h-8 w-auto" />
            </Link>

            <p className="text-sm leading-relaxed text-foreground/70 font-default max-w-xs">
              Premium boutique hair salon
              <br />
              where artistry meets luxury.
            </p>

            <div className="space-y-3 pt-2">
              <p className="font-mono text-[10px] tracking-[0.2em] text-primary flex items-center gap-2">
                FOLLOW OUR STUDIO
                <span aria-hidden="true">&rarr;</span>
              </p>
              <div className="flex items-center gap-2">
                {socials.map((social, i) => {
                const Icon = social.icon;
                return <Button key={social.name} data-index={i} asChild variant="outline" size="icon" className="rounded-lg h-9 w-9 border border-border bg-transparent hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all duration-200">
                      <Link to={social.href} aria-label={social.name}>
                        <Icon className="h-4 w-4" />
                      </Link>
                    </Button>;
              })}
              </div>
            </div>
          </div>

          {}
          <div className="space-y-6">
            <div className="flex items-center gap-3">
              
              <Separator className="flex-1 bg-border" />
            </div>
            <h3 className="font-mono text-xs tracking-[0.25em] text-primary font-default">
              NAVIGATE
            </h3>
            <MenuProvider menu_id="3">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="space-y-6">
            <div className="flex items-center gap-3">
              
              <Separator className="flex-1 bg-border" />
            </div>
            <h3 className="font-mono text-xs tracking-[0.25em] text-primary font-default">
              SERVICES
            </h3>
            <ul className="space-y-3">
              {servicesLinks.map((item, i) => <li key={item.label} data-index={i}>
                  <Link to={item.to} className="text-foreground/80 hover:text-primary transition-colors duration-200 text-sm tracking-wide font-default">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="space-y-6">
            <div className="flex items-center gap-3">
              
              <Separator className="flex-1 bg-border" />
            </div>
            <h3 className="font-mono text-xs tracking-[0.25em] text-primary font-default">
              STUDIO
            </h3>
            <div className="space-y-4 text-sm">
              <div>
                <p className="font-mono text-[10px] tracking-[0.2em] text-foreground/50 mb-1.5">
                  LOCATION
                </p>
                <address className="not-italic font-mono text-xs leading-relaxed text-foreground/85 tracking-wider">
                  123 STYLE AVENUE
                  <br />
                  SUITE 500 / LUXE DISTRICT
                </address>
              </div>

              <div>
                <p className="font-mono text-[10px] tracking-[0.2em] text-foreground/50 mb-1.5">
                  HOURS
                </p>
                <p className="font-mono text-xs leading-relaxed text-foreground/85 tracking-wider">
                  TUE-FRI 10:00-19:00
                  <br />
                  SAT 09:00-17:00
                </p>
              </div>

              <div>
                <p className="font-mono text-[10px] tracking-[0.2em] text-foreground/50 mb-1.5">
                  CONTACT
                </p>
                <div className="space-y-1">
                  <Link to="mailto:hello@velvetshears.com" className="block font-mono text-xs text-foreground/85 hover:text-primary transition-colors tracking-wider">
                    hello@velvetshears.com
                  </Link>
                  <Link to="tel:+15551234567" className="block font-mono text-xs text-foreground/85 hover:text-primary transition-colors tracking-wider">
                    (555) 123-4567
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        {}
        <div className="relative my-10 lg:my-14">
          <div className="flex items-center">
            <Plus className="h-3 w-3 text-foreground/40 -ml-1.5" aria-hidden="true" />
            <div className="flex-1 h-px" style={{
            backgroundImage: "repeating-linear-gradient(to right, var(--border) 0, var(--border) 6px, transparent 6px, transparent 12px)"
          }} />
            <Plus className="h-3 w-3 text-foreground/40 -mr-1.5" aria-hidden="true" />
          </div>
        </div>

        {}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="font-mono text-[11px] tracking-[0.15em] text-foreground/50">© 2026 VELVET SHEARS // ALL RIGHTS RESERVED</p>

          <div className="flex items-center gap-3 flex-wrap font-mono text-[11px] tracking-[0.15em] text-foreground/50">
            {tickerItems.map((item, i) => <span key={item} data-index={i} className="flex items-center gap-3">
                {i > 0 && <span className="text-primary/60" aria-hidden="true">
                    &middot;
                  </span>}
                <span className="hover:text-primary transition-colors">{item}</span>
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}